var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTargetDateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 19.5,
    height: 19.5,
    rx: 5.75,
    fill: "#EFFCFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 19.5,
    height: 19.5,
    rx: 5.75,
    stroke: "#34656D",
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4037_2553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 5.83333V7.49999M6.25 9.16666H13.75M8.33333 5.83333V7.49999M12.0833 10.8333H9.58333M10.4167 12.5H7.91667M7.91667 10.8333H7.92083M12.0833 12.5H12.0875M7.08333 6.66666H12.9167C13.3769 6.66666 13.75 7.03976 13.75 7.49999V13.3333C13.75 13.7936 13.3769 14.1667 12.9167 14.1667H7.08333C6.6231 14.1667 6.25 13.7936 6.25 13.3333V7.49999C6.25 7.03976 6.6231 6.66666 7.08333 6.66666Z",
    stroke: "#34656D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4037_2553"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetDateIcon);
export default __webpack_public_path__ + "static/media/target_date_icon.fb829cfef8a4e891c1a2a7b5b25514ea.svg";
export { ForwardRef as ReactComponent };